import { ErrorDialogPlugin } from '@/plugins/GlobalDialog';

export default class ErrorDialogModel {
  public show(errors: string|string[], onConfirm: VoidFunction|false = false): void {
    const errorsPayload = typeof errors === 'string' ? [errors] : errors;

    ErrorDialogPlugin.$eventBus.$emit('show-error-dialog', {
      errors: errorsPayload,
      onConfirm,
    })
  }
}
